
class SimulationParameters {
    constructor(paramDict) {

        this.parseParamDict(paramDict);
        this.setupDefaultParams();
    }

    parseParamDict(paramDict) {
        this.simulationName = paramDict["Simulation_Name"];

        //Parameters related to hiring/firing/training
        this.trainCost = parseInt(paramDict["TrainCost"]);
        this.hireTime = parseInt(paramDict["Hire_Time_Hours"]);
        this.fireTime = parseInt(paramDict["Fire_Time_Hours"]);
        this.trainTime = parseInt(paramDict["Train_Time_Hours"]);

        //Parameters related to the simulation process
        this.isManual = paramDict["Sim_Type"] == "Manual";
        this.spawnProjectRate = null
        if (paramDict["Spawn_Project_Hour_Rate"] != "" && paramDict["Spawn_Project_Hour_Rate"] != null) {
            this.spawnProjectRate = parseInt(paramDict["Spawn_Project_Hour_Rate"]);
        }

        //Parameters related to the initial setup
        this.projectNames = paramDict["Projects"].split(';');
        this.startProjectAmount = parseInt(paramDict["Start_Project_Amount"]);
        this.startResourcesAmounts = paramDict["Start_Resources"].split(';').map(Number);

        //Parameters related to the visuals
        this.projectsPerSort = null;
        if (paramDict["Projects_Per_Sort"] != "" && paramDict["Projects_Per_Sort"] != null) {
            this.projectsPerSort = parseInt(paramDict["Projects_Per_Sort"]);
        }
        this.showGraphs = paramDict["Show_Graph"] == "Yes";

        this.showResourceOverload = paramDict["Show_Overload_Resource_Bar"] == "Yes";
        this.allowResourceChange = paramDict["Allow_Resource_Change"] == "Yes";
        this.allowPortfolioPlanning = paramDict["Allow_Portfolio_Planning"] == "Yes";

        this.simulationMaxDurationDays = parseInt(paramDict["Stops_At_Day"])
        this.simulationMaxDurationHours = this.simulationMaxDurationDays * 8;

        this.throughputVisible = paramDict["Throughput_Visible"] == "Yes";

        this.futureLoadMultiplier = parseFloat(paramDict["Fut_Load_Multiplier"]);
        this.averageLoadMultiplier = parseFloat(paramDict["Average_Load_Multiplier"]);

        this.WaitingTimeAnimationShape = paramDict["WaitingTimeAnimationShape"];

        if(this.WaitingTimeAnimationShape == "C"){
            this.graphShape = "circle";
            this.graphParams = paramDict["LineairShape"];
        }

        if(this.WaitingTimeAnimationShape == "L"){
            this.graphShape = "lineair";
            this.graphParams = paramDict["LineairShape"].split(';');
        }
    }

    setupDefaultParams() {
        this.delayPerProjectFraction = 0.07;
        this.penaltyPerHour = 200 / 8;
        this.costPerLabourHour = 60;

        this.resourceParams = [{ name: "Blue", id: "B", maxAmount: 3 },
        { name: "Orange", id: "O", maxAmount: 3 },
        { name: "Indigo", id: "I", maxAmount: 3 },
        { name: "Maroon", id: "M", maxAmount: 3 },
        { name: "Aqua", id: "A", maxAmount: 3 },
        { name: "Pink", id: "P", maxAmount: 3 }]
    }
}

module.exports = { SimulationParameters };
